import { render, staticRenderFns } from "./FaultSummaryCards.vue?vue&type=template&id=511c70a2"
import script from "./FaultSummaryCards.vue?vue&type=script&lang=js"
export * from "./FaultSummaryCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports